const metaOgObject = {
  ru: {
    homePage: {
      title: "Dushanbe24 — купить авиабилеты онлайн",
      type: "website",
      url: "https://as.dushanbe24.ru/",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description:
        "Dushanbe24 — удобный сервис поиска и покупки авиабилетов. Сравните цены сотен авиакомпаний, забронируйте рейс онлайн за несколько минут.",
      site_name: "Dushanbe24",
    },
    flightsList: {
      title: "Все направления рейсов | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/flights",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description:
        "Все популярные направления авиарейсов на Dushanbe24. Сравните цены и купите авиабилеты онлайн по выгодным ценам.",
      site_name: "Dushanbe24",
    },
    airlines: {
      title: "Авиакомпании — рейсы и маршруты | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/airlines",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description:
        "Обзоры авиакомпаний на Dushanbe24. Расписание, маршруты, флот. Выберите лучшего перевозчика.",
      site_name: "Dushanbe24",
    },
    aboutPage: {
      title: "О компании | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/about",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description: "Узнайте об Dushanbe24 — надёжном онлайн-сервисе покупки авиабилетов в Таджикистане.",
      site_name: "Dushanbe24",
    },
    contactsPage: {
      title: "Контакты | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/contacts",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description: "Свяжитесь с командой Dushanbe24. Мы готовы помочь с покупкой авиабилетов.",
      site_name: "Dushanbe24",
    },
    servicesPage: {
      title: "Услуги | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/services",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description: "Услуги Dushanbe24: поиск авиабилетов, бронирование рейсов, визовая поддержка.",
      site_name: "Dushanbe24",
    },
    partnersPage: {
      title: "Партнёры | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/partners",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description: "Партнёры и поставщики Dushanbe24 — ведущие авиакомпании и агентства.",
      site_name: "Dushanbe24",
    },
  },
  en: {
    homePage: {
      title: "Dushanbe24 — Buy Airline Tickets Online",
      type: "website",
      url: "https://as.dushanbe24.ru/",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description:
        "Dushanbe24 — search and book cheap flights online. Compare prices from hundreds of airlines and complete your booking in minutes.",
      site_name: "Dushanbe24",
    },
    flightsList: {
      title: "All Flight Routes | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/flights",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description: "Explore all flight directions on Dushanbe24. Compare prices and book cheap airline tickets online.",
      site_name: "Dushanbe24",
    },
    airlines: {
      title: "Airlines — Flights & Routes | Dushanbe24",
      type: "website",
      url: "https://as.dushanbe24.ru/airlines",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description: "Airline reviews on Dushanbe24. Schedules, routes, fleet. Find your ideal carrier.",
      site_name: "Dushanbe24",
    },
  },
  tj: {
    homePage: {
      title: "Dushanbe24 — Харидани чиптаҳои ҳавопаймо онлайн",
      type: "website",
      url: "https://as.dushanbe24.ru/",
      image: "https://as.dushanbe24.ru/images/og-default.png",
      description:
        "Dushanbe24 — ҷустуҷӯ ва харидани чиптаҳои ҳавопаймо онлайн. Нархҳои садҳо ширкати ҳавопаймоиро муқоиса кунед.",
      site_name: "Dushanbe24",
    },
  },
};

export default metaOgObject;
